/* RESPONSIBLE TEAM: team-messenger */
import ApplicationAdapter from 'embercom/adapters/application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'messenger_settings/availability';
  },
});
